import { render, staticRenderFns } from "./DiseaseModal.vue?vue&type=template&id=1187c4c6&"
import script from "./DiseaseModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DiseaseModal.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1187c4c6')) {
      api.createRecord('1187c4c6', component.options)
    } else {
      api.reload('1187c4c6', component.options)
    }
    module.hot.accept("./DiseaseModal.vue?vue&type=template&id=1187c4c6&", function () {
      api.rerender('1187c4c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/DiseaseFilters/components/DiseaseModal.vue"
export default component.exports